import { getResource } from '@rst/libs-ts'
import React, { MouseEvent } from 'react'
import styled, { css, StyledComponent, useTheme } from 'styled-components'
import { IconForInputType } from './icon-for-input'
import { IconNameType } from './icon-name-type'
export * from './icon-for-input'
export * from './icon-name-type'

if (process.env.NODE_ENV === 'development') {
	var head = document.getElementsByTagName('head')[0]
	var link = document.createElement('link')
	link.rel = 'stylesheet'
	link.type = 'text/css'
	link.href = getResource('https://rsttur.ru/rst-icons/style.css')
	link.media = 'all'
	head.appendChild(link)
}

type RstIconType = {
	type: IconNameType
	className?: string
	disabled?: boolean
	innerRef?: React.Ref<any>
	[key: string]: any
}

type RstIconForInputType = {
	type: IconForInputType
	className?: string
	disabled?: boolean
	innerRef?: React.Ref<any>
	[key: string]: any
}

type StyledIconType = {
	onClick?: (any: any) => any
	disabled?: boolean
}

const RstIcon: ((props: RstIconType) => any) & {
	Icon: StyledComponent<'i', any, StyledIconType, never>
} = ({ type: t, className = '', innerRef, ...props }) => {
	const theme = useTheme()
	const type = t === 'none' ? 'rst-stars_fill' : t
	//@ts-expect-error
	const iconType = theme?.icons ? `${type}-theme` : type
	const settings = {
		ref: innerRef,
		className: `${t === 'none' ? 'none-icon ' : ''}${iconType} ${className}`,
		...props,
	}

	return <Icon {...settings} />
}

const RstIconForInput: React.FC<RstIconForInputType> = ({
	type,
	className = '',
	innerRef,
	...props
}) => {
	const theme = useTheme()
	//@ts-expect-error
	const iconType = theme?.icons ? `${type}-theme` : type
	const settings = {
		ref: innerRef,
		className: `${iconType} ${className}`,
		...props,
	}

	return <Icon {...settings} />
}

const Icon = styled.i<StyledIconType>`
	font-family: ${({ theme }) => theme.icons || 'RSTIcons'} !important;
	/* speak: none; */
	font-style: normal;
	font-weight: normal;
	font-variant: normal;
	text-transform: none;
	line-height: 1;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	&.none-icon {
		color: #bebebe;
		&:after {
			content: '';
			display: block;
			width: 139%;
			height: 1px;
			border-bottom: 1px solid red;
			transform: rotate(-45deg) translateY(-2px);
			transform-origin: left;
		}
	}
	${({ onClick }) =>
		onClick &&
		css`
			cursor: pointer;
		`}
	${({ disabled }) =>
		disabled &&
		css`
			opacity: 0.7;
			cursor: auto;
		`}
`

RstIcon.Icon = Icon

export { RstIcon, RstIconForInput }
